// Roof type catalogue. Each entry's `Svg` is rendered with the isometric
// 3-D art from lib/roofIsoArt.jsx — used in the roof-type selector + builder
// step 2. The 2-D measurement plan view (RoofPlanSVG) is keyed by `id`
// separately and unaffected.
import React from "react";
import { IsoRoof } from "./roofIsoArt";

const Iso = (id) => () => <IsoRoof id={id} />;

export const ROOF_TYPES = [
  { id: "gable-to-gable", name: "Gable to Gable", category: "Pitched", Svg: Iso("gable-to-gable"), complexity: 1 },
  { id: "hip-to-hip", name: "Hip to Hip", category: "Pitched", Svg: Iso("hip-to-hip"), complexity: 2 },
  { id: "mono-pitch", name: "Mono-pitch", category: "Pitched", Svg: Iso("mono-pitch"), complexity: 1 },
  { id: "lean-to", name: "Lean-to", category: "Pitched", Svg: Iso("lean-to"), complexity: 1 },
  { id: "flat", name: "Flat Roof", category: "Flat", Svg: Iso("flat"), complexity: 1 },
  { id: "l-shaped", name: "L-Shaped", category: "Pitched", Svg: Iso("l-shaped"), complexity: 3 },
  { id: "t-shaped", name: "T-Shaped", category: "Pitched", Svg: Iso("t-shaped"), complexity: 3 },
  { id: "intersecting", name: "Intersecting", category: "Pitched", Svg: Iso("intersecting"), complexity: 3 },
  { id: "dormer", name: "Dormer Roof", category: "Pitched", Svg: Iso("dormer"), complexity: 3 },
  { id: "mansard", name: "Mansard", category: "Pitched", Svg: Iso("mansard"), complexity: 3 },
  { id: "dutch-barn", name: "Dutch Barn", category: "Pitched", Svg: Iso("dutch-barn"), complexity: 3 },
  { id: "unequal-pitch", name: "Unequal Pitch", category: "Pitched", Svg: Iso("unequal-pitch"), complexity: 2 },
  { id: "valley", name: "Valley Roof", category: "Pitched", Svg: Iso("valley"), complexity: 3 },
  { id: "parapet", name: "Parapet", category: "Flat", Svg: Iso("parapet"), complexity: 2 },
  { id: "stepped-terraces", name: "Stepped Terraces", category: "Flat", Svg: Iso("stepped-terraces"), complexity: 3 },
  { id: "complex", name: "Complex Hips & Valleys", category: "Pitched", Svg: Iso("complex"), complexity: 4 },
];

export const ROOF_CATEGORIES = [
  { id: "Pitched", label: "Pitched", subtypes: ["Concrete Tiles", "Clay Tiles", "Natural Slate", "Fibre Cement Slate"] },
  { id: "Flat", label: "Flat", subtypes: ["EPDM", "GRP Fibreglass", "Torch-on Felt", "Liquid Systems"] },
  { id: "Metal", label: "Metal", subtypes: ["Standing Seam", "Composite Panels", "Corrugated Sheeting"] },
  { id: "Leadwork", label: "Leadwork", subtypes: ["Flashings", "Valleys", "Aprons", "Gullies"] },
];
